import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import "./Need.css";
import RichTextContent, { CmsText } from "../../../RichTextContent/RichTextContent";
import { useIndustrySection } from "../../../../context/IndustryPageContext";
import { resolveMediaUrl } from "../../../../utils/resolveMediaUrl";

const Need = () => {
  const { section, loading } = useIndustrySection("need");

  const bgSrc = useMemo(() => {
    const url = section?.media?.primary?.url;
    return url ? resolveMediaUrl(url) : "";
  }, [section]);

  if (loading || !section?.fields) return null;

  const fields = section.fields;

  return (
    <section className="extra">
      <div className="extra-card">
        {bgSrc ? <img src={bgSrc} alt="" className="extra-bg" /> : null}

        {fields.title ? (
          <CmsText content={fields.title} as="h2" />
        ) : null}

        {fields.description ? (
          <RichTextContent content={fields.description} />
        ) : null}

        {fields.buttonLink ? (
          <Link to={fields.buttonLink} className="buttonclip extra-btn">
            <CmsText content={fields.buttonText} as="span" />
          </Link>
        ) : null}
      </div>
    </section>
  );
};

export default Need;
